export const FILE_INLINE_CARD_PARTS = ['container', 'icon', 'label'] as const;
